import * as firebase from 'firebase';

var config = {
  apiKey: "AIzaSyDseUcUWkx-vSUqNwg6uc3pbzQvVnZ5vR4",
  authDomain: "bus-tracking-53b49.firebaseapp.com",
  databaseURL: "https://bus-tracking-53b49.firebaseio.com",
  projectId: "bus-tracking-53b49",
  storageBucket: "",
  messagingSenderId: "156054828292"
};


const fire = firebase.initializeApp(config);
const auth = firebase.auth();
const db = fire.database();

export {
  fire,
  auth,
  db
};


// WEBPACK FOOTER //
// ./src/firebase/firebase.js